import { get_axios_file_instance, api_variables } from "@/apis/variables.js";

var axios_instance = get_axios_file_instance(api_variables.SERVICE_FILE_UPLOAD);

const state = {
    data: {}
};
const mutation = {
    addEntity: (state, payload) => {
        //console.log("payload add", payload);
        state.data = payload;
    }
};
const actions = {
    async upload({ commit }, payload) {
        try {
            let res = await axios_instance.post("/", payload);
            return res;
        } catch (err) {
            //console.log(err);
        }
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutation
};